import _isObject from 'lodash/isObject';
import _isArray from 'lodash/isArray';
import _unset from 'lodash/unset';
import _get from 'lodash/get';
import { DateTime } from 'luxon';

import store from '@/store';
import { timeConstants } from '@/lib/constants';

/**
 * NOTE: This might require call to isGlobalSkipKey() here, see commit:
 * https://github.com/RetailArchitects/loft/commit/54fdf21d3ee4b326c4e8b4f6d75500f8fe20aee6
 */
// REFACTOR: instead of skippedKeys, can we skip objects without _classname?
const skippedKeys = ['original', 'restricted_attributes', 'adjsourceattrs'];

const pruneSalesPersons = (object) => {
  if (!object) return object;
  const obj = object;
  Object.keys(obj).forEach((key) => {
    if (key === 'salesperson1' || key === 'salesperson2') {
      _unset(obj, key);
    }
    if (_isObject(obj[key])) {
      if (_isArray(obj[key])) {
        obj[key] = obj[key].filter((el) => {
          return pruneSalesPersons(el);
        });
      } else if (!skippedKeys.includes(key)) {
        obj[key] = pruneSalesPersons(obj[key]);
      }
    }
  });
  return obj;
};

const validateData = (value, { format }) => {
  const { DATEFORMAT, DATETIMEFORMAT } = timeConstants;

  if (['date', 'date-time'].includes(format)) {
    const date = DateTime.fromSQL(value);
    if (date.isValid) { // If valid, then format date and date-time values.
      if (format === 'date') value = date.toFormat(DATEFORMAT);
      else if (!DateTime.fromFormat(value, DATETIMEFORMAT).isValid) value = date.toFormat(DATETIMEFORMAT);
    }
  }
  return value;
};

const checkPropertyTypes = (object, className) => {
  const obj = object;
  const meta = store.getters['meta/class_schema'](className);
  const keys = Object.keys(obj);

  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index];
    if (_isObject(obj[key])) {
      if (_isArray(obj[key]) && obj[key].length) {
        for (let idx = 0; idx < obj[key].length; idx += 1) {
          if (_isObject(obj[key][idx])) { // Only iterate on collections of objects
            obj[key][idx] = checkPropertyTypes(obj[key][idx], obj[key][idx]._classname);
          }
        }
      } else if (!skippedKeys.includes(keys)) {
        obj[key] = checkPropertyTypes(obj[key], obj[key]._classname);
      }
    } else if (!skippedKeys.includes(keys) && obj[key] && meta) {
      // Skip property checking if no meta data is present (e.g. something custom), if key is an original, or if no value is present
      if (_get(meta, `properties[${key}]`)) obj[key] = validateData(obj[key], meta.properties[key]);
    }
  }
  return obj;
};

export {
  pruneSalesPersons,
  checkPropertyTypes,
};
